import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerStartEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerStartEventDTO.validationSchema()
  );

  readonly data: RoomMixerStartEvent;

  constructor(data: RoomMixerStartEvent) {
    this.data = JsonSchemaValidator.assert(
      RoomMixerStartEventDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

export interface RoomMixerStartEventJson extends RoomMixerStartEvent {}

interface RoomMixerStartEvent {
  roomId: RoomId;
}
